import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';

const StyledTableCell = styled(TableCell)((props) => ({
  padding: '6px',
  minWidth: props.minWidth || '',
  maxWidth: props.maxWidth || '',
  overflowWrap: props.overflowWrap || '',
  textAlign: props.textAlign || '',
}));

const MainQuestionPrint = ({ question, numCases, answer }) => {
  const needToRenderTable = (type) => type.toLowerCase() === 'oneof' || type.toLowerCase() === 'multiplechoice';

  const renderAnswerForOneOf = (properties, caseIndex, optionUuid) => {
    let checked = false;
    if (answer && answer.answers[caseIndex]) {
      checked = answer.answers[caseIndex].answer === optionUuid;
    }
    return checked
      ? <span style={properties.style}>&#10687;</span>
      : <span style={properties.style}>&#9711;</span>;
  };

  const renderAnswerForMultipleChoice = (properties, caseIndex, optionUuid) => {
    let checked = false;
    if (answer && answer.answers[caseIndex]) {
      checked = answer.answers[caseIndex].choices[optionUuid];
    }
    return checked
      ? <span>&#128505;</span>
      : <span style={properties.style}>&#9634;</span>;
  };

  const renderAnswerForText = (properties, caseIndex) => {
    let textAnswer = '';
    if (answer && answer.answers && answer.answers[caseIndex]) {
      textAnswer = answer.answers[caseIndex].answer;
    }
    return <span className="f7 b">{textAnswer || '____'}</span>;
  };

  const renderCases = () => {
    const tableCell = [];
    for (let i = 0; i < numCases; i += 1) {
      tableCell.push(
        <StyledTableCell
          key={`p${i}`}
          textAlign="center"
        >
          {`P${i + 1}`}
        </StyledTableCell>,
      );
    }
    return tableCell;
  };

  const renderCells = ({ type, question: innerQuestion }, optionUuid) => {
    const tableCell = [];
    const defaultType = { type: 'text', style: { width: '0' }, renderAnswer: renderAnswerForText };
    const mapping = {
      oneof: { type: 'radio', renderAnswer: renderAnswerForOneOf },
      multiplechoice: { type: 'checkbox', renderAnswer: renderAnswerForMultipleChoice },
      arbitrarystring: { ...defaultType, renderAnswer: renderAnswerForText },
    };
    const choosenType = mapping[type.toLowerCase()] || defaultType;
    for (let caseIndex = 0; caseIndex < numCases; caseIndex += 1) {
      const answerProperties = {
        type: choosenType.type,
        style: choosenType.style,
        questioUuid: innerQuestion.uuid,
      };
      tableCell.push(
        <StyledTableCell
          key={`caseIndex-${caseIndex}`}
          minWidth={type.toLowerCase() !== 'oneof' ? '35px' : ''}
          maxWidth={type.toLowerCase() !== 'oneof' ? '50px' : ''}
          overflowWrap={type.toLowerCase() !== 'oneof' ? 'anywhere' : ''}
          textAlign="center"
        >
          {choosenType.renderAnswer(answerProperties, caseIndex, optionUuid)}
        </StyledTableCell>,
      );
    }
    return tableCell;
  };

  return (
    <div
      key={question.id}
      className="pt2 pb3"
    >
      <div><b>{question.question.text}</b></div>
      <Paper elevation={3}>
        <Table size="small" aria-label="a dense table" className="ba">
          <TableHead>
            <TableRow>
              <StyledTableCell />
              {renderCases(numCases)}
            </TableRow>
          </TableHead>
          <TableBody>
            {needToRenderTable(question.type)
              ? question.options.map((option) => (
                <TableRow key={option.uuid}>
                  <StyledTableCell component="th" scope="row">
                    {option.text}
                  </StyledTableCell>
                  {renderCells(question, option.uuid)}
                </TableRow>
              ))
              : (
                <TableRow>
                  <StyledTableCell
                    minWidth="200px"
                    maxWidth="200px"
                    overflowWrap="break-word"
                  >
                    {question.question.text}
                  </StyledTableCell>
                  {renderCells(question)}
                </TableRow>
              )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

export default MainQuestionPrint;

MainQuestionPrint.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    options: PropTypes.object,
  }).isRequired,
  numCases: PropTypes.number.isRequired,
  answer: PropTypes.object.isRequired,
};
